module.exports = __webpack_public_path__ + "assets/certificate_pdf/20220812175749Certificate.876376c2.pdf";